import { render, staticRenderFns } from "./form-builder.html?vue&type=template&id=1d3df5a7&scoped=true&external"
import script from "./form-builder.js?vue&type=script&lang=js&external"
export * from "./form-builder.js?vue&type=script&lang=js&external"
import style0 from "./form-builder.scss?vue&type=style&index=0&id=1d3df5a7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3df5a7",
  null
  
)

export default component.exports